import vue       from 'vue';
import { default as Component } from 'vue-class-component';

@Component({
  template: require('./dashborad-navigation-block.html'),
})
export class DashboradNavigationBlock extends vue {
  dashnavigation = true;

  get lessonsData() {
    return this.$store.state.lessons;
  }

  get userData() {
    return this.$store.state.user;
  }

  get courseTitle() {
    return this.$store.state.courseTitle;
  }

  get userProgress() {
    return this.$store.state.progress.filter((lesson) => {
      return !lesson.hasOwnProperty('reset');
    });
  }

  get lessonLastPassIndex() {
    if (this.userProgress.length > 0 && this.lessonsData.length > 0) {
      const lessonLast = this.lessonsData.map((lesson) => {return lesson.id;}).indexOf(this.userProgress[this.userProgress.length - 1].id, this.userProgress.length - 2);
      if (this.userProgress[lessonLast] !== undefined && this.lessonsData[lessonLast].type === 'App\\Models\\Quiz' && this.userProgress[lessonLast].resultPercentage == undefined){
        return this.lessonsData.map((lesson) => {
          return lesson.id;
        }).indexOf(this.userProgress[this.userProgress.length - 2].id);
      }
      else{
        return this.lessonsData.map((lesson) => {return lesson.id;}).indexOf(this.userProgress[this.userProgress.length - 1].id, this.userProgress.length - 2);
      }
    }
    return -1;
  }

  get nextLesson() {
    if (this.lessonLastPassIndex > -1) {
      if (this.lessonLastPassIndex + 1 <= this.lessonsData.length) {
        return this.lessonsData[this.lessonLastPassIndex + 1];
      }
    } else {
      return this.lessonsData.find((lesson) => {
        return lesson.order === '000';
      });
    }
  }
  isLesson(lesson) {
    if (lesson) {
      return (lesson.type === 'App\\Models\\Lesson') ? true : false;
    }
  }

  isQuiz(lesson) {
    if (lesson) {
      return (lesson.type === 'App\\Models\\Quiz') ? true : false;
    }
  }
  get dashnavClass() {
    return (this.dashnavigation) ? 'collapse navbar-collapse' : 'navbar-collapse';
  }

  dashnavToggle() {
    this.dashnavigation = !this.dashnavigation;
  }
}
